import React, { useState, useEffect, useContext } from "react"

import { navigate } from "gatsby"

import { GET_CONFIG_DATA } from "../../components/shared-actions/get-config-data"
import { CANDIDATE_EDUCATION_DATA_FETCH } from "../../components/candidate-profile/actions/educationAction"

import { CANDIDATE_STEP_MENU } from "../../constants/profile-menu"
import { SIDEBAR_MENU_STEP } from "../../constants/sidebar-menu"

import { GlobalAuthContext } from "../../context/authContext"

import ModalComponent from "../../components/modal/modal"
import CandidateProfileLayout from "../../components/layout/candidate-profile"
import EducationForm from "../../components/candidate-profile/form/education-form"
import DeleteConfirmForm from "../../components/candidate-profile/form/delete-confirm"
import TrainingInputForm from "../../components/candidate-profile/form/training-input"
import EducationInputForm from "../../components/candidate-profile/form/education-input"

const EducationPage = ({ location }) => {
  const [images, setImages] = useState([])

  const [configData, setConfigData] = useState({})

  const [education, setEducation] = useState([])

  const [addEducation, setAddEducation] = useState(false)
  const [addTraining, setAddTraining] = useState(false)

  const [trainingFormData, setTrainingFormData] = useState({
    title: "",
    imageUrl: "",
    url: "",
    description: "",
  })

  const [educationFormData, setEducationFormData] = useState({
    instituteName: "",
    instituteEmail: "",
    degreeName: "",
    to: "",
    from: "",
    running: false,
    description: "",
  })

  const [uploadedImage, setUploadedImage] = useState()

  const handleTrainingModalHide = (value, id) => {
    if (id !== undefined) {
      setAddTraining(value)
      const image = images.filter(image => image.id === id)
      setTrainingFormData({
        ...trainingFormData,
        title: image[0].title,
        imageUrl: image[0].image,
        url: image[0].url,
        description: image[0].description,
        id: id,
        type: "PATCH",
      })
    } else {
      setAddTraining(value)
      setUploadedImage()
      setTrainingFormData({
        title: "",
        imageUrl: "",
        url: "",
        description: "",
      })
    }
  }

  const handleEducationModalHide = (value, id) => {
    if (id !== undefined) {
      setAddEducation(value)
      const edu = education.filter(exp => exp.id === id)
      setEducationFormData({
        ...educationFormData,
        companyName: edu[0].college,
        degreeName: edu[0].degree,
        degreetype: edu[0].degreetype,
        about: edu[0].description,
        from: new Date(edu[0].from_year),
        to: edu[0].to_year === "Current" ? null : new Date(edu[0].to_year),
        running: !!(edu[0].to_year === "Current"),
        type: "PATCH",
        id: id,
      })
    } else {
      setAddEducation(value)
      setEducationFormData({
        companyName: "",
        description: "",
        degreeName: "",
        degreetype: null,
      })
    }
  }

  const [isLoading, setLoading] = useState(false)
  const { state, dispatch } = useContext(GlobalAuthContext)
  const [showDeleteForm, setShowDeleteForm] = useState(false)

  const [id, setID] = useState(null)
  const [type, setType] = useState(null)

  const handleDeleteConfirmModalHide = (value, itemId, deleteType) => {
    setShowDeleteForm(value)
    if (itemId && deleteType) {
      setID(itemId)
      setType(deleteType)
    } else {
      setShowDeleteForm(false)
      setID(null)
    }
  }

  useEffect(
    () => {
      try {
        const id = JSON.parse(localStorage.getItem("user")).id
        if (state && state.user && state.user.role === 2) {
          CANDIDATE_EDUCATION_DATA_FETCH(
            id,
            dispatch,
            setEducation,
            setImages,
            setLoading
          )
        }
        if (!state.config) {
          GET_CONFIG_DATA(setConfigData, dispatch)
        } else {
          setConfigData(state.config)
        }
      } catch (err) {
        dispatch({ type: "LOGOUT" })
        navigate("/login")
      }
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [
      dispatch,
      state.config,
      showDeleteForm,
      addEducation,
      addTraining,
      state.user,
    ]
  )

  return (
    <CandidateProfileLayout
      menu={CANDIDATE_STEP_MENU}
      sidebarMenu={SIDEBAR_MENU_STEP}
      activeSidebar="Edit Profile"
      active="Education"
      title="Education"
      location={location}
    >
      <ModalComponent
        onHide={() => handleTrainingModalHide}
        setShow={handleTrainingModalHide}
        show={addTraining}
      >
        <TrainingInputForm
          trainingFormData={trainingFormData}
          setTrainingFormData={setTrainingFormData}
          setAddTraining={setAddTraining}
          uploadedImage={uploadedImage}
          setUploadedImage={setUploadedImage}
        />
      </ModalComponent>
      <ModalComponent
        onHide={handleEducationModalHide}
        setShow={setAddEducation}
        show={addEducation}
      >
        <EducationInputForm
          configData={configData}
          educationFormData={educationFormData}
          setAddEducation={setAddEducation}
          setEducationFormData={setEducationFormData}
        />
      </ModalComponent>
      <ModalComponent
        onHide={() => handleDeleteConfirmModalHide}
        setShow={handleDeleteConfirmModalHide}
        show={showDeleteForm}
      >
        <DeleteConfirmForm
          id={id}
          type={type}
          isCompany={false}
          setShowDeleteForm={setShowDeleteForm}
        />
      </ModalComponent>

      <EducationForm
        isLoading={isLoading}
        education={education}
        setEducation={setEducation}
        images={images}
        setImages={setImages}
        setDelete={handleDeleteConfirmModalHide}
        setAddEducation={handleEducationModalHide}
        setAddTraining={handleTrainingModalHide}
      />
    </CandidateProfileLayout>
  )
}

export default EducationPage
